import type { GetLatestObligationAssessmentResultsResponseRow } from '@risksmart-app/drizzle/src/types';
import type { GetLatestObligationAssessmentResultsQuery } from '@risksmart-app/web-graphql-client/generated/graphql';
import { GetLatestObligationAssessmentResultsDocument } from '@risksmart-app/web-graphql-client/generated/graphql';
import { createQueryHook } from 'src/utils';

type UseGetLatestObligationAssessmentResultsArgs = Record<string, never>;

/**
 * Register-wide "latest" obligation assessment results feed for the
 * obligations dashboard. The data-layer read returns rows ordered by
 * TestDate desc (nulls last), CreatedAtTimestamp desc — the consumer picks
 * the latest row per obligation by first match, exactly like the legacy
 * Hasura ordering.
 */
export const useGetLatestObligationAssessmentResults = createQueryHook<
  UseGetLatestObligationAssessmentResultsArgs,
  GetLatestObligationAssessmentResultsResponseRow[],
  GetLatestObligationAssessmentResultsQuery
>({
  trpcQueryOptions: (trpc) =>
    trpc.frontend.obligationAssessmentResult.latestObligationAssessmentResults.queryOptions(),
  mapTrpcDataToGraphQL: (data) => ({ obligation_assessment_result: data }),
  graphqlDocument: GetLatestObligationAssessmentResultsDocument,
});
